var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var controlState = {
    activeView: "homepage",
    operate: "create_extract",
    controlDisplay: false,
    attachmentUpload: false,
    scale: 0.5,
    hiddenList: false,
    paint: false,
    popup: {
        show: false,
        data: {
            onOk: function () { return null; },
            onCancel: function () { return null; },
            title: "",
            msg: "",
        },
    },
};
export var controlReducer = function (state, action) {
    if (state === void 0) { state = controlState; }
    var payload = action.payload;
    switch (action.type) {
        case "changeControl":
            return __assign(__assign({}, state), payload);
        case "changeStartPaint":
            return __assign(__assign({}, state), { paint: payload });
        case "showPopUp":
            return __assign(__assign({}, state), { popup: payload });
        case "hiddenPopUp":
            return __assign(__assign({}, state), { popup: __assign({}, controlState.popup) });
        case "changeHiddenList":
            return __assign(__assign({}, state), { hiddenList: payload });
        case "changeScale":
            return __assign(__assign({}, state), { scale: payload });
        case "changeActiveView":
            return __assign(__assign({}, state), { activeView: payload });
        case "changeOperate":
            return __assign(__assign({}, state), { operate: payload });
        default:
            return __assign({}, state);
    }
};
